const getMockProfile = () => ({
  id: 129,
  first_name: 'John',
  last_name: 'Doe',
  full_name: 'John Doe',
  email: 'jdoe@intellum.com',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris rutrum orci sapien, vitae scelerisque tellus scelerisque eu. Duis ultricies, mauris et aliquet consequat, urna velit luctus libero, vitae vehicula odio lorem a lorem. Praesent feugiat et erat et convallis. Donec orci metus, ultricies fermentum libero eget, posuere rutrum erat. Sed convallis pharetra ipsum. Suspendisse condimentum quis orci a tempus. Praesent fringilla eu ex quis ultrices. Mauris rutrum sapien ac feugiat tincidunt.',
  company_name: 'Intellum',
  job_title: 'Developer',
  locale: 'en',
  authority: 'superadmin',
  profile_url: 'johndoe12345',
  picture: {
    w3200: 'https://picsum.photos/3200/3200',
    w2400: 'https://picsum.photos/2400/2400',
    w1600: 'https://picsum.photos/1600/1600',
    w1100: 'https://picsum.photos/1100/1100',
    w800: 'https://picsum.photos/800/800',
    w550: 'https://picsum.photos/550/550',
  },
  organization_id: 3,
  followed_topics_count: 3,
  public_profile: false,
  twitter_handle: 'johndoe',
  linkedin_url: 'https://www.linkedin.com/in/johndoe',
  website_url: 'https://intellum.com',
  reputation_points: 1000,
  credentials_count: 10,
  trophies_count: 0,
  can_follow_topics: true,
});

const getMockTopicsFollowed = () => ([
  {
    section_name: 'Default',
    topics: [
      {
        topic_id: 11,
        topic_name: 'Retail Sales',
      },
      {
        topic_id: 13,
        topic_name: 'Sales Demonstrations',
      },
      {
        topic_id: 14,
        topic_name: 'Record-Keeping',
      },
    ],
  },
  {
    section_name: 'Default 2',
    topics: [
      {
        name: 'Software',
        path: '/student/catalog/list?category_ids=6-software',
      },
      {
        name: 'Distribution',
        path: '/student/catalog/list?category_ids=7-distribution',
      },
    ],
  },
]);

const getMockChallenges = () => ({
  active: [
    {
      challenge_id: 17,
      name: "Knoxville's Only One-Night-A-Week Indoor Climb-o-Rama",
      challenge_type: 'topic',
      starts_at: '2023-02-01T00:00:00-05:00',
      ends_at: '2023-07-15T00:00:00-04:00',
      gold_earned: 100,
      completed_at: null,
      challenge_picture: {
        w3200: 'https://picsum.photos/3200/3200',
        w2400: 'https://picsum.photos/2400/2400',
        w1600: 'https://picsum.photos/1600/1600',
        w1100: 'https://picsum.photos/1100/1100',
        w800: 'https://picsum.photos/800/800',
        w550: 'https://picsum.photos/550/550',
        w96: 'https://picsum.photos/96/96',
      },
    },
    {
      challenge_id: 18,
      name: 'Knoxville',
      challenge_type: 'topic',
      starts_at: '2023-02-01T00:00:00-05:00',
      ends_at: '2023-07-15T00:00:00-04:00',
      gold_earned: 100,
      completed_at: null,
    },
    {
      challenge_id: 19,
      name: 'Knoxville',
      challenge_type: 'topic',
      starts_at: '2023-02-01T00:00:00-05:00',
      ends_at: '2023-07-15T00:00:00-04:00',
      gold_earned: 100,
      completed_at: null,
    },
  ],
  completed: [
    {
      challenge_id: 17,
      name: "Knoxville's Only One-Night-A-Week Indoor Climb-o-Rama",
      challenge_type: 'topic',
      starts_at: '2023-02-01T00:00:00-05:00',
      ends_at: '2023-07-15T00:00:00-04:00',
      gold_earned: 100,
      completed_at: null,
      challenge_picture: {
        w3200: 'https://picsum.photos/3200/3200',
        w2400: 'https://picsum.photos/2400/2400',
        w1600: 'https://picsum.photos/1600/1600',
        w1100: 'https://picsum.photos/1100/1100',
        w800: 'https://picsum.photos/800/800',
        w550: 'https://picsum.photos/550/550',
        w96: 'https://picsum.photos/96/96',
      },
    },
    {
      challenge_id: 18,
      name: 'Knoxville',
      challenge_type: 'topic',
      starts_at: '2023-02-01T00:00:00-05:00',
      ends_at: '2023-07-15T00:00:00-04:00',
      gold_earned: 100,
      completed_at: null,
    },
    {
      challenge_id: 19,
      name: 'Knoxville',
      challenge_type: 'topic',
      starts_at: '2023-02-01T00:00:00-05:00',
      ends_at: '2023-07-15T00:00:00-04:00',
      gold_earned: 100,
      completed_at: null,
    },
  ],
});

const getMockCredential = () => ({
  user_credential: {
    id: 1,
    user_id: 129,
    account_id: 3,
    expires_on: null,
    created_at: '2022-12-12T20:59:58-05:00',
    has_user_been_notified: true,
    completion_id: 456,
    access_token: 'pGs3KoL4NHs9QQZcPNx6eWtL',
    credly_badge_key: null,
    reputation_points: 150,
    score: null,
  },
  credential: {
    id: 1,
    name: 'Top Cat Parent',
    allow_sharing: true,
    badge_absolute_url: 'https://picsum.photos/500/500',
    created_at: '2022-12-12T20:59:43-05:00',
    credential_type: 'Cats',
    credly_badge_template_key: null,
    description: 'This is a description',
  },
  reputation_earned: [
    {
      id: 1,
      name: 'cooking',
      reputation_points: 50,
    },
    {
      id: 2,
      name: 'drawing',
      reputation_points: 50,
    },
    {
      id: 3,
      name: 'coding',
      reputation_points: 50,
    },
  ],
  gold_earned: 100,
});

const getMockCredentials = () => ([
  {
    id: 1,
    name: 'Test Credential 1',
    allow_sharing: true,
    badge_absolute_url: 'https://picsum.photos/150/150',
    created_at: '2022-11-14T13:46:26-05:00',
    credential_type: 'Test Group 1',
    credly_badge_template_key: null,
    description: 'This is the credential description field!',
  },
  {
    id: 3,
    name: 'Test Credential 3',
    allow_sharing: true,
    badge_absolute_url: 'https://picsum.photos/150/150',
    created_at: '2022-11-14T13:46:26-05:00',
    credential_type: '',
    credly_badge_template_key: null,
    description: 'This is the credential description field!',
  },
  {
    id: 4,
    name: 'Test Credential 4',
    allow_sharing: true,
    badge_absolute_url: 'https://picsum.photos/150/150',
    created_at: '2022-11-14T13:46:26-05:00',
    credential_type: 'Test Group 1',
    credly_badge_template_key: null,
    description: 'This is the credential description field!',
  },
  {
    id: 2,
    name: 'Test Credential 2',
    allow_sharing: true,
    badge_absolute_url: 'https://picsum.photos/150/150',
    created_at: '2022-11-14T13:46:26-05:00',
    credential_type: 'Test Group 2',
    credly_badge_template_key: null,
    description: 'This is the credential description field!',
  },
]);

const getMockGamification = () => ({
  is_gold_enabled: true,
  gold_redeem_url: 'https://intellum.com',
  has_reached_gold_limit: false,
  gold_balance: 200,
});

const getMockGoldTransactions = () => ([
  {
    id: 4,
    user_id: 103,
    gold_amount: 100,
    description: 'Testing Challenge',
    user_gold_balance: 200,
    notes: 'Only 100 gold were credited instead of 200 because the account gold Cap was 200 at this time, and the user had already earned 100 gold so far this year.',
    code: null,
    created_at_epoch: 1677725773,
  },
]);

const getMockSkills = () => ({
  skills: [
    {
      id: 15,
      name: 'test tag',
      reputation_points: 50,
    },
    {
      id: 16,
      name: 'test tag 2',
      reputation_points: 50,
    },
  ],
  total_reputation_points: 100,
});

const getMockUpNext = () => ([
  {
    id: 0,
    image: 'https://picsum.photos/1600/900',
    name: 'Holistic World View of Disruptive Innovation',
    topics: [
      {
        id: 0,
        name: 'Leverage agile frameworks',
      },
    ],
    type: 'event',
    start_at: '2021-02-22T16:30:00-05:00',
  },
  {
    id: 0,
    image: 'https://picsum.photos/1600/900',
    name: 'Understanding the ads auction',
    topics: [
      {
        id: 0,
        name: 'Launching Your Campaign',
      },
    ],
    type: 'course',
    due_date: '2021-02-22',
  },
  {
    id: 0,
    image: 'https://picsum.photos/1600/900',
    name: 'The Basics',
    topics: [
      {
        id: 0,
        name: 'Creating Inspiring Content',
      },
    ],
    type: 'course',
  },
]);

export {
  getMockChallenges,
  getMockCredential,
  getMockCredentials,
  getMockGamification,
  getMockGoldTransactions,
  getMockProfile,
  getMockSkills,
  getMockTopicsFollowed,
  getMockUpNext,
};
